import 'core-js/modules/es.reflect.to-string-tag.js';
import 'core-js/modules/es.reflect.construct.js';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.array.concat.js';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { __awaiter } from 'tslib';
import { nativeRequest } from '@tencent/ark-request';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.number.max-safe-integer.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.timers.js';
import 'core-js/modules/es.json.stringify.js';
import 'core-js/modules/es.array.some.js';
import 'core-js/modules/es.function.name.js';

/**
 * 通用返回结果类型
 *
 * @class Result
 * @template T
 */
var Result = /** @class */function () {
  function Result(error, data) {
    if (error !== undefined) {
      this.error = error;
    }
    if (data !== undefined) {
      this.data = data;
    }
  }
  return Result;
}();

var BaseLock = /*#__PURE__*/function () {
  function BaseLock(config) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "exclusive";
    _classCallCheck(this, BaseLock);
    // 自身id，用来标记请求资源的对象
    this.id = this.getId();
    var resourceConfig = Object.assign(Object.assign({}, this.getDefaultConfig()), config);
    this.mode = mode;
    this.strategy = resourceConfig.strategy;
    this.period = resourceConfig.period;
    this.autoRenewal = resourceConfig.autoRenewal;
  }
  /**
   * 生成自身id
   *
   * @private
   * @return {*}
   * @memberof BaseLock
   */
  _createClass(BaseLock, [{
    key: "getId",
    value: function getId() {
      var date = new Date();
      var time = "".concat(date.toLocaleDateString(), "-").concat(date.getHours(), ":").concat(date.getMinutes(), ":").concat(date.getSeconds(), ":").concat(date.getMilliseconds());
      return "".concat(time, "-").concat(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
    }
  }]);
  return BaseLock;
}();

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 客户端资源锁
 *
 * @export
 * @class ClientResourceLock
 * @extends {BaseLock}
 */
var ClientResourceLock = /*#__PURE__*/function (_BaseLock) {
  _inherits(ClientResourceLock, _BaseLock);
  var _super = _createSuper$2(ClientResourceLock);
  function ClientResourceLock() {
    _classCallCheck(this, ClientResourceLock);
    return _super.apply(this, arguments);
  }
  _createClass(ClientResourceLock, [{
    key: "lock",
    value:
    /**
     * 上锁
     *
     * @param {string} key 请求的资源id
     * @param {LockKeyParams} optional
     * @return {*}  {Promise<ILockResult>}
     * @memberof ClientResourceLock
     */
    function lock(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.mode === "exclusive" /* LockMode.EXCLUSIVE */)) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return this.lockExclusive(key, optional);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
              _context.next = 6;
              return this.lockShared(key, optional);
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 检测锁
     *
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<Result<ILockItem>>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "detectKey",
    value: function detectKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.mode === "exclusive" /* LockMode.EXCLUSIVE */)) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return this.detectExclusiveKey(key);
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 4:
              _context2.next = 6;
              return this.detectSharedKey(key);
            case 6:
              return _context2.abrupt("return", _context2.sent);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 释放锁
     *
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<boolean>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "release",
    value: function release(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.mode === "exclusive" /* LockMode.EXCLUSIVE */)) {
                _context3.next = 4;
                break;
              }
              _context3.next = 3;
              return this.releaseExclusiveKey(key);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
              _context3.next = 6;
              return this.releaseSharedKey(key);
            case 6:
              return _context3.abrupt("return", _context3.sent);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * 获取默认配置
     *
     * @public
     * @return {*}  {ILockConfig}
     * @memberof ClientResourceLock
     */
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      return {
        strategy: 0 /* LockStrategy.ONCE */,

        // 永不过期
        period: -1,
        autoRenewal: true
      };
    }
    /**
     * 排他锁
     *
     * @param {string} key 请求的资源id
     * @param {LockKeyParams} optional 传入的锁额外信息
     * @return {*}  {Promise<ILockResult>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "lockExclusive",
    value: function lockExclusive(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;
        var item, req, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // 暂时保留tabId
              item = {
                tabId: this.id,
                expire: this.period === -1 ? -1 : Date.now() + this.period,
                optional: optional
              };
              req = {
                command: 'lock',
                key: key,
                item: item
              };
              _context4.next = 4;
              return new Promise(function (resolve) {
                _this.invokeNative(req, resolve);
              });
            case 4:
              result = _context4.sent;
              if (!result.error) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return", {
                isSuccess: false,
                data: result.data
              });
            case 7:
              if (!(result.data.id === this.id)) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", {
                isSuccess: true,
                data: result.data
              });
            case 9:
              return _context4.abrupt("return", {
                isSuccess: false,
                data: result.data
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * 共享锁
     *
     * @private
     * @param {string} key 请求的资源id
     * @param {LockKeyParams} optional 传入的锁额外信息
     * @return {*}  {Promise<ILockResult>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "lockShared",
    value: function lockShared(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              throw new Error("method not implemented with ".concat(key, " ").concat(optional));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
    }
    /**
     * 检测排他锁的情况
     *
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<Result>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "detectExclusiveKey",
    value: function detectExclusiveKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;
        var req, clientResult, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              req = {
                command: 'detectKey',
                key: key
              };
              _context6.next = 3;
              return new Promise(function (resolve) {
                _this2.invokeNative(req, resolve);
              });
            case 3:
              clientResult = _context6.sent;
              result = new Result(undefined, clientResult.result);
              if (!clientResult.err_code) {
                _context6.next = 8;
                break;
              }
              // detectKey异常
              result.error = new Error("".concat(clientResult.err_code));
              return _context6.abrupt("return", result);
            case 8:
              return _context6.abrupt("return", result);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
    }
    /**
     * 检测共享锁
     *
     * @private
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<Result>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "detectSharedKey",
    value: function detectSharedKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              throw new Error("method not implemented with ".concat(key));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
    }
    /**
     * 释放排他锁
     *
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<boolean>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "releaseExclusiveKey",
    value: function releaseExclusiveKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this3 = this;
        var req, result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              req = {
                command: 'release',
                key: key
              };
              _context8.next = 3;
              return new Promise(function (resolve) {
                _this3.invokeNative(req, resolve);
              });
            case 3:
              result = _context8.sent;
              if (!result.error) {
                _context8.next = 6;
                break;
              }
              return _context8.abrupt("return", false);
            case 6:
              return _context8.abrupt("return", true);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
    }
    /**
     * 释放共享锁
     *
     * @private
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<boolean>}
     * @memberof ClientResourceLock
     */
  }, {
    key: "releaseSharedKey",
    value: function releaseSharedKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              throw new Error("method not implemented with ".concat(key));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
    }
  }, {
    key: "wrapResult",
    value: function wrapResult(res) {
      var _a;
      // 返回的结果中可能仍然带有tabId，此时将tabId改为id
      if ((_a = res.result) === null || _a === void 0 ? void 0 : _a.tabId) {
        res.result.id = res.result.tabId;
        delete res.result.tabId;
      }
      if (res.err_msg || res.err_code) {
        var error = new Error(res.err_msg || res.err_code);
        return new Result(error, res.result);
      }
      return new Result(undefined, res.result || {});
    }
  }, {
    key: "invokeNative",
    value: function invokeNative(req, resolve) {
      var _this4 = this;
      var _a;
      if ((_a = window === null || window === void 0 ? void 0 : window.tdocs) === null || _a === void 0 ? void 0 : _a.getClientMutexLock) {
        window.tdocs.getClientMutexLock(req).then(function (res) {
          var finalResult = res;
          if (!res.result) finalResult = {
            result: res
          };
          resolve(_this4.wrapResult(finalResult));
        });
      } else {
        nativeRequest.invoke({
          schema: 'jsapi',
          namespace: 'docx',
          method: 'clientMutexLock',
          params: req,
          callback: function callback(res) {
            resolve(_this4.wrapResult(res));
          }
        });
      }
    }
  }]);
  return ClientResourceLock;
}(BaseLock);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// 延迟检测的时间
var detectDelayTime = 200;
var LocalStorageLock = /*#__PURE__*/function (_BaseLock) {
  _inherits(LocalStorageLock, _BaseLock);
  var _super = _createSuper$1(LocalStorageLock);
  function LocalStorageLock() {
    var _this;
    _classCallCheck(this, LocalStorageLock);
    _this = _super.apply(this, arguments);
    _this.renewalHandler = new Map();
    return _this;
  }
  _createClass(LocalStorageLock, [{
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      return {
        strategy: 0 /* LockStrategy.ONCE */,
        period: 5 * 60 * 1000,
        autoRenewal: true
      };
    }
    /**
     * 上锁
     *
     * @param {string} key 请求资源的id
     * @param {LockKeyParams} optional 传入的额外信息
     * @return {*} {Promise<ILockResult>}
     * @memberof LocalStorageLock
     */
  }, {
    key: "lock",
    value: function lock(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.mode === "exclusive" /* LockMode.EXCLUSIVE */)) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return this.lockExclusive(key, optional);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
              _context.next = 6;
              return this.lockShared(key, optional);
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     *  检测锁的情况
     *
     * @param {string} key 请求资源的id
     * @return {*} {Promise<Result<undefined | ILockItem>>}
     * @memberof LocalStorageLock
     */
  }, {
    key: "detectKey",
    value: function detectKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var yKey, detectResult, lockYValue, lockYItem;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              yKey = this.getYKey(key);
              detectResult = new Result(undefined, undefined);
              lockYValue = localStorage.getItem(yKey);
              if (lockYValue) {
                lockYItem = JSON.parse(lockYValue); // 超过有效期 锁失效 所以需要有效期大于当前时间
                if (lockYItem.expire > Date.now()) {
                  detectResult.data = lockYItem;
                }
              }
              return _context2.abrupt("return", detectResult);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 释放锁
     *
     * @param {string} key 请求资源的id
     * @return {*} {Promise<boolean>}
     * @memberof LocalStorageLock
     */
  }, {
    key: "release",
    value: function release(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.mode === "exclusive" /* LockMode.EXCLUSIVE */)) {
                _context3.next = 4;
                break;
              }
              _context3.next = 3;
              return this.releaseExclusiveLock(key);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
              _context3.next = 6;
              return this.releaseSharedLock(key);
            case 6:
              return _context3.abrupt("return", _context3.sent);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "lockExclusive",
    value: function lockExclusive(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;
        var lockResult;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return new Promise(function (resolve, reject) {
                _this2.tryToLockKey(key, optional, resolve, reject);
              }).then(function (item) {
                if (_this2.autoRenewal) {
                  _this2.renewal(key, _this2.period);
                }
                return {
                  isSuccess: true,
                  data: item
                };
              }, function (item) {
                // 竞争锁失败
                var xKey = _this2.getXKey(key);
                if (localStorage.getItem(xKey) === _this2.id) {
                  localStorage.removeItem(xKey);
                }
                return {
                  isSuccess: false,
                  data: item
                };
              });
            case 2:
              lockResult = _context4.sent;
              return _context4.abrupt("return", lockResult);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
    }
  }, {
    key: "lockShared",
    value: function lockShared(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              throw new Error("method not implemented with ".concat(key, " ").concat(optional, " "));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
    }
  }, {
    key: "releaseExclusiveLock",
    value: function releaseExclusiveLock(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var xKey, yKey, oldYValue, oldYItem, timeOutId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              xKey = this.getXKey(key);
              yKey = this.getYKey(key);
              oldYValue = localStorage.getItem(yKey); // 如果未被上锁，则直接返回false
              if (oldYValue) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return", false);
            case 5:
              oldYItem = JSON.parse(oldYValue); // 只有自己页面锁住 才能释放
              if (!(oldYItem.id === this.id)) {
                _context6.next = 12;
                break;
              }
              localStorage.removeItem(yKey);
              // 如果x锁还是自己页面种的话  那就一起删掉吧
              if (localStorage.getItem(xKey) === this.id) {
                localStorage.removeItem(xKey);
              }
              // 取消自动续期
              timeOutId = this.renewalHandler.get(key);
              if (timeOutId) {
                clearTimeout(timeOutId);
                this.renewalHandler["delete"](key);
              }
              return _context6.abrupt("return", true);
            case 12:
              return _context6.abrupt("return", false);
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "releaseSharedLock",
    value: function releaseSharedLock(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              throw new Error("method not implemented with ".concat(key));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
    }
    /**
     * 续期
     *
     * @param {string} key 请求资源的id
     * @param {number} period 续期长度
     * @return {*}
     * @memberof LocalStorageLock
     */
  }, {
    key: "renewal",
    value: function renewal(key, period) {
      var _this3 = this;
      // 取消上一个的自动续期
      var oldTimeOutId = this.renewalHandler.get(key);
      if (oldTimeOutId) {
        clearTimeout(oldTimeOutId);
      }
      var timeOutId = setTimeout(function () {
        var yKey = _this3.getYKey(key);
        var oldYValue = localStorage.getItem(yKey);
        if (!oldYValue) {
          // 没有y锁 那就不续期了
          return;
        }
        var oldYItem = JSON.parse(oldYValue);
        if (oldYItem.id !== _this3.id) {
          return;
        }
        var newYItem = Object.assign(Object.assign({}, oldYItem), {
          expire: Date.now() + _this3.period
        });
        localStorage.setItem(_this3.getYKey(key), JSON.stringify(newYItem));
        // 启动下一个延期续期指令
        _this3.renewal(key, period);
      }, period * 0.85);
      this.renewalHandler.set(key, timeOutId);
      return timeOutId;
    }
  }, {
    key: "getXKey",
    value: function getXKey(key) {
      return "".concat(LocalStorageLock.PREFIX_LOCK_X, "_").concat(key);
    }
  }, {
    key: "getYKey",
    value: function getYKey(key) {
      return "".concat(LocalStorageLock.PREFIX_LOCK_Y, "_").concat(key);
    }
    /**
     * 尝试上锁
     *
     * @private
     * @param {string} key 请求资源的id
     * @param {LockKeyParams} optional 传入的锁额外信息
     * @param {CallbackFunction} onSuccess 上锁成功时的回调
     * @param {CallbackFunction} onError 上锁失败时的回调
     * @return {*}
     * @memberof LocalStorageLock
     */
  }, {
    key: "tryToLockKey",
    value: function tryToLockKey(key, optional, onSuccess, onError) {
      var xKey = this.getXKey(key);
      var yKey = this.getYKey(key);
      // 1、写入X锁
      localStorage.setItem(xKey, this.id);
      // 2. 查看Y锁
      var valueY = localStorage.getItem(yKey);
      if (valueY) {
        var _lockItemY = JSON.parse(valueY);
        // Y锁被其他tab写了值，那就看看有效期有没有到  如果到了，那就当做没有被占有 如果没到，那就说明Y锁被其他tab占有着。本次竞争锁失败
        if (_lockItemY.expire > Date.now()) {
          // 还没到有效期
          this.handleDetectLockFail(key, optional, onSuccess, onError);
          return;
        }
      }
      // 3. 占有Y锁
      var lockItemY = {
        id: this.id,
        expire: Date.now() + this.period,
        optional: optional
      };
      localStorage.setItem(yKey, JSON.stringify(lockItemY));
      // 4. 查看X锁
      var valueX = localStorage.getItem(xKey);
      if (valueX !== this.id) {
        // 有其他tab竞争该锁, 要隔一会再来看看 不能直接看
        this.delayDetect(key, optional, onSuccess, onError);
        return;
      }
      // 没有人占有锁，拿到锁了
      onSuccess(lockItemY);
    }
    /**
     * 延迟检测
     *
     * @private
     * @param {string} key 请求资源的id
     * @param {LockKeyParams} optional 传入的锁额外信息
     * @param {CallbackFunction} onSuccess 上锁成功的回调
     * @param {CallbackFunction} onError 上锁失败的回调
     * @memberof LocalStorageLock
     */
  }, {
    key: "delayDetect",
    value: function delayDetect(key, optional, onSuccess, onError) {
      var _this4 = this;
      var yKey = this.getYKey(key);
      var lockYValue = localStorage.getItem(yKey);
      var lockYItem = JSON.parse(lockYValue || '{}');
      setTimeout(function () {
        if (lockYValue && lockYItem.id === _this4.id && lockYItem.expire > Date.now()) {
          // 说明Y锁被我们拿到了
          onSuccess(lockYItem);
          return;
        }
        // 被其他人占有了Y锁 本次竞争锁失败
        _this4.handleDetectLockFail(key, optional, onSuccess, onError);
      });
    }
    /**
     * 获取锁失败
     *
     * @private
     * @param {string} key 请求的资源id
     * @param {LockKeyParams} optional 传入的锁额外信息
     * @return {*}
     * @memberof LocalStorageLock
     */
  }, {
    key: "handleDetectLockFail",
    value: function handleDetectLockFail(key, optional, onSuccess, onError) {
      var _this5 = this;
      var yKey = this.getYKey(key);
      var lockYValue = localStorage.getItem(yKey);
      var lockYItem = JSON.parse(lockYValue || '{}');
      // 如果只竞争一次，则结束竞争锁
      if (this.strategy === 0 /* LockStrategy.ONCE */) {
        onError(lockYItem);
        return;
      }
      setTimeout(function () {
        return _this5.tryToLockKey(key, optional, onSuccess, onError);
      }, detectDelayTime);
    }
  }]);
  return LocalStorageLock;
}(BaseLock);
LocalStorageLock.PREFIX_LOCK_X = 'prefix_lock_x';
LocalStorageLock.PREFIX_LOCK_Y = 'prefix_lock_y';

function isSupportLocalStorage() {
  return !!window.localStorage;
}
function isSupportWebLock() {
  return !!navigator.locks;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var WebLock = /*#__PURE__*/function (_BaseLock) {
  _inherits(WebLock, _BaseLock);
  var _super = _createSuper(WebLock);
  function WebLock() {
    var _this;
    _classCallCheck(this, WebLock);
    _this = _super.apply(this, arguments);
    _this.releaseLockHandlerMap = new Map();
    _this.lockManager = navigator.locks;
    return _this;
  }
  /**
   * 上锁
   *
   * @param {string} key 请求的资源id
   * @param {LockKeyParams} optional 传入的关于锁的额外信息
   * @return {*}  {Promise<ILockResult>}
   * @memberof WebLock
   */
  _createClass(WebLock, [{
    key: "lock",
    value: function lock(key, optional) {
      var _this2 = this;
      return new Promise(function (resolve) {
        var lockResult = {
          isSuccess: false,
          // 锁的相关信息
          data: {
            id: _this2.id,
            // webLock中不需要expire
            expire: -1,
            optional: optional
          }
        };
        _this2.lockManager.request(key, {
          ifAvailable: true,
          mode: _this2.mode
        }, function (lock) {
          if (!lock) {
            // 没有拿到锁，则返回失败结果
            resolve(lockResult);
            return Promise.resolve();
          }
          if (isSupportLocalStorage()) {
            try {
              // 需要在localStorage保存相关的锁信息，detectKey调用时需要返回
              localStorage.setItem(key, JSON.stringify(lockResult));
            } catch (error) {}
          }
          // 拿到锁了，返回成功结果
          lockResult.isSuccess = true;
          resolve(lockResult);
          return _this2.keepLock(key);
        });
      });
    }
    /**
     * 释放锁
     *
     * @param {string} key 请求资源的id
     * @return {*}  {boolean}
     * @memberof WebLock
     */
  }, {
    key: "release",
    value: function release(key) {
      // 该资源锁不是自己持有，则释放失败
      if (!this.releaseLockHandlerMap.has(key)) {
        return Promise.resolve(false);
      }
      // 释放锁
      this.releaseLockHandlerMap.get(key)();
      // 删除锁的相关信息
      this.releaseLockHandlerMap["delete"](key);
      try {
        localStorage.removeItem(key);
      } catch (error) {}
      return Promise.resolve(true);
    }
    /**
     * 查询锁的情况，如果是worker线程查询，则无法获得信息
     *
     * @param {string} key 请求资源的id
     * @return {*}  {Promise<Result<undefined | ILockItem>>}
     * @memberof WebLock
     */
  }, {
    key: "detectKey",
    value: function detectKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var lockList, isOccupied, isSelf, detectResult, lockItem, lockInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.lockManager.query();
            case 2:
              lockList = _context.sent;
              // 是否被上锁
              isOccupied = lockList.held.some(function (value) {
                return value.name === key;
              }); // 是否是自己占有锁
              isSelf = !!this.releaseLockHandlerMap.has(key);
              detectResult = new Result(undefined, undefined); // 如果未上锁或自己占有锁
              if (!(!isOccupied || isSelf)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", detectResult);
            case 8:
              lockItem = {
                id: '',
                expire: -1,
                optional: {}
              }; // 考虑到worker无法访问localStorage，因此无法获取信息
              if (isSupportLocalStorage()) {
                try {
                  lockInfo = localStorage.getItem(key);
                  lockItem = JSON.parse(lockInfo);
                } catch (error) {}
              }
              detectResult.data = lockItem;
              return _context.abrupt("return", detectResult);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      return {
        strategy: 0 /* LockStrategy.ONCE */,
        period: -1,
        autoRenewal: false
      };
    }
    /**
     * 保持锁不被释放
     *
     * @private
     * @param {string} key 请求资源的id
     * @return {*}  {Promise<void>}
     * @memberof WebLock
     */
  }, {
    key: "keepLock",
    value: function keepLock(key) {
      var _this3 = this;
      return new Promise(function (resolve) {
        var _a;
        // 如果重复上共享锁，会先释放上次的锁
        (_a = _this3.releaseLockHandlerMap.get(key)) === null || _a === void 0 ? void 0 : _a();
        _this3.releaseLockHandlerMap.set(key, resolve);
      });
    }
  }]);
  return WebLock;
}(BaseLock);

/**
 * web端资源锁，内部由webLock或者localStorage实现
 *
 * @export
 * @class WebResourceLock
 */
var WebResourceLock = /*#__PURE__*/function () {
  function WebResourceLock(userConfig) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "exclusive";
    _classCallCheck(this, WebResourceLock);
    if (!isSupportLocalStorage() && !isSupportWebLock()) {
      throw new Error('当前环境不支持使用锁机制');
    }
    this.resourceLock = isSupportWebLock() ? new WebLock(userConfig, mode) : new LocalStorageLock(userConfig, mode);
  }
  /**
   * 上锁
   *
   * @param {string} key 请求的资源id
   * @param {LockKeyParams} optional 传入的额外信息
   * @return {*}  {Promise<ILockResult>}
   * @memberof WebResourceLock
   */
  _createClass(WebResourceLock, [{
    key: "lock",
    value: function lock(key, optional) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.resourceLock.lock(key, optional);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 释放锁
     *
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<boolean>}
     * @memberof WebResourceLock
     */
  }, {
    key: "release",
    value: function release(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.resourceLock.release(key);
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 检测锁的情况
     *
     * @param {string} key 请求的资源id
     * @return {*}  {Promise<Result>}
     * @memberof WebResourceLock
     */
  }, {
    key: "detectKey",
    value: function detectKey(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.resourceLock.detectKey(key);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * 获取默认配置
     *
     * @return {*}  {ILockConfig}
     * @memberof WebResourceLock
     */
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      return this.resourceLock.getDefaultConfig();
    }
  }]);
  return WebResourceLock;
}();

/**
 * 获取锁 策略
 *
 * @enum {number}
 */
var LockStrategy;
(function (LockStrategy) {
  // 只尝试一次
  LockStrategy[LockStrategy["ONCE"] = 0] = "ONCE";
  // 重复尝试
  LockStrategy[LockStrategy["RETRY"] = 1] = "RETRY";
})(LockStrategy || (LockStrategy = {}));
/**
 * 锁模式
 *
 * @export
 * @enum {number}
 */
var LockMode;
(function (LockMode) {
  // 排他锁
  LockMode["EXCLUSIVE"] = "exclusive";
  // 共享锁
  LockMode["SHARED"] = "shared";
})(LockMode || (LockMode = {}));

export { ClientResourceLock, LockMode, LockStrategy, WebResourceLock };
//# sourceMappingURL=index.js.map
